import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface SelectedRuleParams {
  orWhen: Array<{ andWhen: Array<{ [conditionName: string]: string }> }>;
  andThen: Array<{ [actionName: string]: string }>;
}

@Component({
  selector: 'rule-template-selector',
  template: `<div>
    @switch (template) {
      @default {
        <div class="loader-container">
          <app-main-loader-lottie></app-main-loader-lottie>
        </div>
      }
      @case ('order-created') {
        <order-created-template
          [conditions]="conditions"
          [actions]="actions"
          [selectedRuleParams]="selectedRuleParams"
          [onChangeConditionSelect]="onChangeConditionSelect"
          [onChangeOperatorSelect]="onChangeOperatorSelect"
          [onChangeOperator2Select]="onChangeOperator2Select"
          [onChangeActionSelect]="onChangeActionSelect"
          [onChangeNotVerifiedName]="onChangeNotVerifiedName"
          [notVerifiedName]="notVerifiedName"
          [onRemoveCondition]="onRemoveCondition"></order-created-template>
      }
      @case ('order-assigned') {
        <order-assigned-template
          [conditions]="conditions"
          [actions]="actions"
          [selectedRuleParams]="selectedRuleParams"
          [onChangeConditionSelect]="onChangeConditionSelect"
          [onChangeOperatorSelect]="onChangeOperatorSelect"
          [onChangeOperator2Select]="onChangeOperator2Select"
          [onChangeActionSelect]="onChangeActionSelect"
          [onRemoveCondition]="onRemoveCondition"></order-assigned-template>
      }
      @case ('order-fulfilled') {
        <order-fulfilled-template
          [conditions]="conditions"
          [actions]="actions"
          [selectedRuleParams]="selectedRuleParams"
          [onChangeConditionSelect]="onChangeConditionSelect"
          [onChangeOperatorSelect]="onChangeOperatorSelect"
          [onChangeOperator2Select]="onChangeOperator2Select"
          [onChangeActionSelect]="onChangeActionSelect"
          [onRemoveCondition]="onRemoveCondition"></order-fulfilled-template>
      }
      @case ('order-tracked') {
        <order-tracked-template
          [conditions]="conditions"
          [actions]="actions"
          [selectedRuleParams]="selectedRuleParams"
          [onChangeConditionSelect]="onChangeConditionSelect"
          [onChangeOperatorSelect]="onChangeOperatorSelect"
          [onChangeOperator2Select]="onChangeOperator2Select"
          [onChangeActionSelect]="onChangeActionSelect"
          [onRemoveCondition]="onRemoveCondition"></order-tracked-template>
      }
    }
  </div>`,
  styles: [
    `
      .loader-container {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ],
  standalone: false,
})
export class RuleTemplateSelectorComponent {
  @Input() template: string;
  @Input() conditions: Array<any>;
  @Input() actions: Array<any>;
  @Input() selectedRuleParams?: SelectedRuleParams;
  @Input() notVerifiedName: string;
  @Input() internalName: string;
  @Output() onChangeConditionSelect: EventEmitter<any> = new EventEmitter();
  @Output() onChangeActionSelect: EventEmitter<any> = new EventEmitter();
  @Output() onChangeOperatorSelect: EventEmitter<any> = new EventEmitter();
  @Output() onChangeOperator2Select: EventEmitter<any> = new EventEmitter();
  @Output() onRemoveCondition: EventEmitter<any> = new EventEmitter();
  @Output() onChangeNotVerifiedName: EventEmitter<any> = new EventEmitter();
  @Output() onInternalNameChange: EventEmitter<any> = new EventEmitter();
}
